import React from 'react';
import DownloadApp from '../../components/DownloadApp';

export default async function action({ locale }) {
    return {
        title: locale && locale.startsWith('es')
            ? 'Descarga la App - NAVEGA'
            : 'Download the App - NAVEGA',
        description: locale && locale.startsWith('es')
            ? 'Descarga NAVEGA - La app para rentar botes desde cualquier lugar del mundo'
            : 'Download NAVEGA - The app to rent boats from anywhere in the world',
        chunk: 'download',
        component: <DownloadApp locale={locale} />,
    };
}
